import { cn } from "@newxsystems/shared";
import type { IBackgroundContainerBlockProps } from "./BackgroundContainerBlock.props";

const backgrounds: Record<string, string> = {
  canvas: "ravioli-background-canvas",
  paper: "ravioli-background-canvas",
  mint: "bg-primary text-primary-foreground",
  blue: "ravioli-background-ink-muted",
  violet: "ravioli-background-ink",
  dots: "ravioli-background-canvas",
};

export const BackgroundContainerBlock = ({
  background,
  components,
  parentClass,
}: IBackgroundContainerBlockProps) => {
  if (!components) return null;

  return (
    <div
      className={cn(background ? backgrounds[background] : backgrounds.canvas, parentClass)}
      data-background={background || "canvas"}
      data-background-container=""
    >
      {components}
    </div>
  );
};

BackgroundContainerBlock.displayName = "Block::BackgroundContainerBlock";
